import React, { useEffect, useState, useRef } from 'react';
import { servicios } from '../../json/carouselnews';
import './carousel.css';

const ITEMS_TO_SHOW = 4;

const Carouselnews = () => {
    const [currentIndex, setCurrentIndex] = useState(ITEMS_TO_SHOW);
    const [isTransitioning, setIsTransitioning] = useState(true);
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null);

    // Duplicar items al inicio y al final para el bucle infinito visual
    const extendedItems = [
        ...servicios.slice(-ITEMS_TO_SHOW),
        ...servicios,
        ...servicios.slice(0, ITEMS_TO_SHOW)
    ];

    // Auto-avance cada 5 segundos
    useEffect(() => {
        if (!isPaused) {
            intervalRef.current = setInterval(() => {
                setCurrentIndex((prev) => prev + 1);
            }, 5000);
        }
        return () => clearInterval(intervalRef.current);
    }, [isPaused]);

    // Salto infinito sin animación cuando llegamos a los clones
    useEffect(() => {
        if (currentIndex >= servicios.length + ITEMS_TO_SHOW) {
            const timer = setTimeout(() => {
                setIsTransitioning(false);
                setCurrentIndex(ITEMS_TO_SHOW);
                setTimeout(() => setIsTransitioning(true), 50);
            }, 400);
            return () => clearTimeout(timer);
        } else if (currentIndex < ITEMS_TO_SHOW) {
            const timer = setTimeout(() => {
                setIsTransitioning(false);
                setCurrentIndex(servicios.length + ITEMS_TO_SHOW - 1);
                setTimeout(() => setIsTransitioning(true), 50);
            }, 400);
            return () => clearTimeout(timer);
        }
    }, [currentIndex]);

    const nextSlide = () => {
        setCurrentIndex((prev) => prev + 1);
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => prev - 1);
    };

    return (
        <div 
            className="carousel-news-page"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <style>{`
                .carousel-news-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 20px;
                }
                .carousel-news-wrapper {
                    position: relative;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                }
                .carousel-news-viewport {
                    overflow: hidden;
                    width: 100%;
                    border-radius: 12px;
                    padding: 6px 0; 
                }
                .carousel-news-track {
                    display: flex;
                    width: 100%;
                }
                .carousel-slot {
                    flex: 0 0 25%;
                    padding: 0 10px;
                    box-sizing: border-box;
                }
                .carousel-card {
                    background-color: #F9F7F4;
                    border: 1px solid #D4C19C;
                    border-radius: 12px;
                    padding: 24px;
                    min-height: 140px;
                    
                    align-items: flex-start;
                    transition: all 0.3s ease;
                    box-shadow: 0 1px 4px rgba(98, 17, 50, 0.06);
                }
                .carousel-card:hover {
                    border-color: #621132;
                    box-shadow: 0 4px 16px rgba(98, 17, 50, 0.12);

                }
                .carousel-card a {
                    color: #621132;
                    text-decoration: none;
                    display: block;
                    width: 100%;
                }
                .carousel-card h6 {
                    color: #621132;
                    margin: 0;
                    font-family: 'Montserrat-SemiBold', sans-serif;
                    font-size: 0.95rem;
                    line-height: 1.45;
                    text-align: left;
                }
                .carousel-card a:hover h6 {
                    text-decoration: underline;
                }
                .carousel-btn {
                    background-color: #fff;
                    color: #fff;
                    border: none;
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    transition: all 0.2s ease;
                    box-shadow: 0 2px 8px rgba(98, 17, 50, 0.3);
                    z-index: 2;
                }
                .carousel-btn:hover {
                    background-color: #D4C19C;
                    transform: scale(1.08);
                }
                .carousel-btn svg {
                    width: 20px;
                    height: 20px;
                }
                @media (max-width: 992px) {
                    .carousel-slot {
                        flex: 0 0 50%;
                    }
                }
                @media (max-width: 576px) {
                    .carousel-slot {
                        flex: 0 0 100%;
                    }
                    .carousel-btn {
                        width: 36px;
                        height: 36px;
                    }
                    .carousel-btn svg {
                        width: 16px;
                        height: 16px;
                    }
                }
            `}</style>

            <div className="carousel-news-container">
                <div className="carousel-news-wrapper">
                    <button className="carousel-btn" onClick={prevSlide} aria-label="Anterior">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                    </button>

                    <div className="carousel-news-viewport">
                        <div 
                            className="carousel-news-track"
                            style={{
                                transform: `translateX(-${currentIndex * (100 / ITEMS_TO_SHOW)}%)`,
                                transition: isTransitioning ? 'transform 0.4s ease-in-out' : 'none'
                            }}
                        >
                            {extendedItems.map((item, index) => (
                                <div key={`${item.urlRuts}-${index}`} className="carousel-slot">
                                    <div className="carousel-card">
                                        <a 
                                            href={item.urlRuts} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                        >
                                            <h6>{item.descripcion}</h6>
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <button className="carousel-btn" onClick={nextSlide} aria-label="Siguiente">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Carouselnews;